import { FC } from 'react';

import { IconMap } from '../../../shared/sprite';
import { Icon } from '../../../shared/ui';

type Props = {
  isTeamAccessible: boolean;
  teamMembersCount: number;
};

export const VideoStatus: FC<Props> = ({
  isTeamAccessible,
  teamMembersCount,
}) => {
  return (
    <div className="flex flex-nowrap gap-x-1 items-center text-gray-600 text-sm">
      {isTeamAccessible ? (
        <>
          <Icon glyph={IconMap.Users01} width={16} />
          <p className="flex-shrink-0">Team access</p>
        </>
      ) : teamMembersCount <= 1 ? (
        <>
          <Icon glyph={IconMap.Lock} width={16} />
          <p className="flex-shrink-0">Private</p>
        </>
      ) : (
        <>
          <Icon glyph={IconMap.Users01} width={16} />
          <p className="flex-shrink-0">{`${teamMembersCount} members`}</p>
        </>
      )}
    </div>
  );
};

export const VideoStatusShared: FC<{ isCanEdit: boolean }> = ({
  isCanEdit,
}) => {
  return (
    <div className="flex flex-nowrap gap-x-1 items-center text-gray-600 text-sm">
      <p>{isCanEdit ? 'Can Edit' : 'Can View'}</p>
    </div>
  );
};
